import React from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
  VStack,
} from "@chakra-ui/react";

/**
 * DurationInput Component
 * Hours + Minutes inputs with quick +/-30min adjustment buttons
 */
export default function DurationInput({
  hours,
  minutes,
  onChange,
  onAdjust,
  isReadOnly = false,
}) {
  const totalMinutes = hours * 60 + minutes;

  return (
    <FormControl isRequired>
      <FormLabel fontSize="sm" fontWeight="medium" color="gray.700">
        Duration
      </FormLabel>
      <VStack spacing={3} align="stretch">
        <Flex gap={3} align="flex-start">
          {/* Hours Input */}
          <Box flex={1}>
            <Text fontSize="xs" color="gray.600" mb={1}>
              Hrs
            </Text>
            <Input
              type="number"
              min="0"
              value={hours}
              onChange={(e) => onChange('hours', Math.max(0, parseInt(e.target.value) || 0))}
              size="lg"
              borderWidth="2px"
              isReadOnly={isReadOnly}
              bg={isReadOnly ? "gray.50" : "white"}
            />
          </Box>

          {/* Minutes Input */}
          <Box flex={1}>
            <Text fontSize="xs" color="gray.600" mb={1}>
              Min
            </Text>
            <Input
              type="number"
              min="0"
              max="59"
              value={minutes}
              onChange={(e) => onChange('minutes', Math.max(0, Math.min(59, parseInt(e.target.value) || 0)))}
              size="lg"
              borderWidth="2px"
              isReadOnly={isReadOnly}
              bg={isReadOnly ? "gray.50" : "white"}
            />
          </Box>

          {/* Stacked +/-30 buttons */}
          <VStack spacing={1} pt="20px" flexShrink={0}>
            <Button
              onClick={() => onAdjust(30)}
              size="sm"
              colorScheme="gray"
              variant="outline"
              fontSize="xs"
              h="32px"
              px={3}
              w="90px"
              isDisabled={isReadOnly}
            >
              + 30 min
            </Button>
            <Button
              onClick={() => onAdjust(-30)}
              size="sm"
              colorScheme="gray"
              variant="outline"
              fontSize="xs"
              h="32px"
              px={3}
              w="90px"
              isDisabled={isReadOnly}
            >
              - 30 min
            </Button>
          </VStack>
        </Flex>

        {/* Duration Display */}
        <Text fontSize="sm" color="gray.600" textAlign="center">
          Total: {hours}h {minutes}m ({totalMinutes} minutes)
        </Text>
      </VStack>
    </FormControl>
  );
}
